import "prebid.js/modules/akceloBidAdapter"

import type {IPrebidJsBidder} from "header-bidding-client-base/modules/header-bidding/infrastructure/prebid-js/bidders/iPrebidJsBidder";
import type {HeaderBiddingConfig} from "header-bidding-client-base/modules/config/domain/headerBiddingConfig";
import {Bidders} from "header-bidding-base/modules/header-bidding/domain/bidders";
import {PrebidJsBaseBidder} from "./prebidJsBaseBidder";
import {AkceloAdUnit} from "header-bidding-base/modules/config/domain/bidders/akceloConfig";

export class AkceloBidder extends PrebidJsBaseBidder implements IPrebidJsBidder<AkceloAdUnit> {
    public constructor(config: HeaderBiddingConfig) {
        super(config, Bidders.AKCELO);
    }
}
